import { SnackBarService } from "cw-utils";
import { Component, OnDestroy, type OnInit } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { RequireMatch } from "app/validators/requireMatch";
import {
    AttendanceEditProvider,
    InsuranceListProvider,
    PageOptions,
} from "cw-backend";
import { filter } from "lodash";
import { string } from "mathjs";
import { takeUntil, debounceTime, distinctUntilChanged, Subject } from "rxjs";

@Component({
    selector: "dialog-change-insurance.component",
    templateUrl: "./dialog-change-insurance.component.html",
    styleUrls: ["./dialog-change-insurance.component.scss"],
})
export class DialogChangeInsurance implements OnInit, OnDestroy {
    public iOrderId!: any;

    progress: boolean = false;

    insuranceList = new Array<any>();

    insuranceControl = new FormControl(null, [
        Validators.required,
        RequireMatch.bind(this),
    ]);

    pageOptions = new PageOptions();

    private _unsubscribeAll: Subject<any>;

    constructor(
        public dialogRef: MatDialogRef<DialogChangeInsurance>,
        private insuranceListProvider: InsuranceListProvider,
        private attendanceEditProvider: AttendanceEditProvider,
        private snackBarService: SnackBarService,
    ) {
        this.pageOptions.sizePage = 15;
        this._unsubscribeAll = new Subject();
    }

    ngOnInit(): void {
        this.getInsuranceList();
        this.filterInsurance();
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(true);
        this._unsubscribeAll.complete();
    }

    filterInsurance() {
        this.insuranceControl.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged(),
            )
            .subscribe((res) => {
                if (typeof res == "string") {
                    this.pageOptions.argument = res;
                    this.getInsuranceList();
                }
            });
    }

    getInsuranceList() {
        this.insuranceListProvider
            .getPageSimpleList(this.pageOptions, true)
            .then((res) => {
                this.insuranceList = res.body.content;
            });
    }

    displaySimpleFn(object?: any): string | undefined {
        if (object && object.name) {
            return object.name;
        } else {
            return "";
        }
    }

    changeInsurance() {
        if (this.progress == true) {
            return;
        }

        this.progress = true;

        if (!this.iOrderId || !this.insuranceControl.value?.id) {
            this.snackBarService.warnMessage("Dados inválidos");
            this.progress = false;
            return;
        }
        this.attendanceEditProvider
            .chageInsurance(this.iOrderId, this.insuranceControl.value.id)
            .then((res) => {
                this.progress = false;
                this.dimiss();
            })
            .catch((err) => {
                this.progress = false;
                console.error(err);
            });
    }

    dimiss() {
        this.dialogRef.close();
    }
}
